var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2521_49965",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2521_49965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 15.584C11.2584 15.584 11.4763 15.496 11.6523 15.32C11.8277 15.1446 11.9154 14.927 11.9154 14.6673V10.9777C11.9154 10.718 11.8277 10.5041 11.6523 10.3361C11.4763 10.168 11.2584 10.084 10.9987 10.084C10.739 10.084 10.5214 10.1717 10.346 10.3471C10.17 10.5231 10.082 10.7409 10.082 11.0007V14.6902C10.082 14.95 10.17 15.1638 10.346 15.3319C10.5214 15.5 10.739 15.584 10.9987 15.584ZM10.9987 8.25065C11.2584 8.25065 11.4763 8.16265 11.6523 7.98665C11.8277 7.81126 11.9154 7.59371 11.9154 7.33398C11.9154 7.07426 11.8277 6.8564 11.6523 6.6804C11.4763 6.50501 11.2584 6.41732 10.9987 6.41732C10.739 6.41732 10.5214 6.50501 10.346 6.6804C10.17 6.8564 10.082 7.07426 10.082 7.33398C10.082 7.59371 10.17 7.81126 10.346 7.98665C10.5214 8.16265 10.739 8.25065 10.9987 8.25065ZM10.9987 20.1673C9.73064 20.1673 8.53898 19.9265 7.4237 19.445C6.30842 18.964 5.33828 18.3111 4.51328 17.4861C3.68828 16.6611 3.03531 15.6909 2.55436 14.5757C2.07281 13.4604 1.83203 12.2687 1.83203 11.0007C1.83203 9.73259 2.07281 8.54093 2.55436 7.42565C3.03531 6.31037 3.68828 5.34023 4.51328 4.51523C5.33828 3.69023 6.30842 3.03696 7.4237 2.5554C8.53898 2.07446 9.73064 1.83398 10.9987 1.83398C12.2668 1.83398 13.4584 2.07446 14.5737 2.5554C15.689 3.03696 16.6591 3.69023 17.4841 4.51523C18.3091 5.34023 18.9621 6.31037 19.443 7.42565C19.9246 8.54093 20.1654 9.73259 20.1654 11.0007C20.1654 12.2687 19.9246 13.4604 19.443 14.5757C18.9621 15.6909 18.3091 16.6611 17.4841 17.4861C16.6591 18.3111 15.689 18.964 14.5737 19.445C13.4584 19.9265 12.2668 20.1673 10.9987 20.1673ZM10.9987 18.334C13.0306 18.334 14.761 17.6199 16.1898 16.1917C17.6179 14.763 18.332 13.0326 18.332 11.0007C18.332 8.96871 17.6179 7.23835 16.1898 5.80957C14.761 4.3814 13.0306 3.66732 10.9987 3.66732C8.96675 3.66732 7.2367 4.3814 5.80853 5.80957C4.37975 7.23835 3.66536 8.96871 3.66536 11.0007C3.66536 13.0326 4.37975 14.763 5.80853 16.1917C7.2367 17.6199 8.96675 18.334 10.9987 18.334Z",
    fill: "#668295"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ac0d46434c709b9eeab9f7f0501a5964.svg";
export { ForwardRef as ReactComponent };